// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-68899752]{display:flex;justify-content:space-evenly;align-items:center;margin-bottom:10px}.box .numBox[data-v-68899752]{width:50%;margin:0 15px}", ""]);
// Exports
module.exports = exports;
